<!--拆分订单-->
<template>
  <el-dialog
    title="拆单"
    :visible.sync="dialogFormVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog"
  >

    <div ref="print1" style="width: 640px;margin: 0 auto;">

      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="query-table">
        <tr class="noborder">
          <td align="right">订单号：</td>
          <td>{{controlData.erpserial}}</td>
          <td align="right">时&nbsp;&nbsp;间：</td>
          <td>{{controlData.htqd||controlData.adddate}}</td>
          <td align="right">仓&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td>
            <!--<el-select v-model="form.cangkucode" placeholder="请选择" style="width: 135px;" size="mini">-->
            <!--<el-option-->
            <!--v-for="item in jxcstoreData"-->
            <!--:key="item.cangkucode"-->
            <!--:label="item.cangkuname"-->
            <!--:value="item.cangkucode">-->
            <!--</el-option>-->
            <!--</el-select>-->
          </td>
        </tr>
        <tr class="noborder">
          <td align="right" width="60">门&nbsp;&nbsp;&nbsp;&nbsp;店：</td>
          <td width="140">{{controlData.customername}}</td>
          <td align="right" width="40">地&nbsp;&nbsp;址：</td>
          <td width="220">{{controlData.caddress}}</td>
          <td align="right" width="60">联系人：</td>
          <td width="120">{{(controlData.linkman||"")+" " +(controlData.linkmantel||"")}}</td>
        </tr>
        <tr class="noborder">
          <td align="right">服务商：</td>
          <td>{{controlData.applybydname}}</td>
          <td align="right">地&nbsp;&nbsp;址：</td>
          <td>{{controlData.address}}</td>
          <td align="right">联系人：</td>
          <td>{{(controlData.elinkman||"")+" "+(controlData.elinkmantel||"")}}</td>
        </tr>

        <tr>
          <td colspan="6" style="border:none">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="query-table">
              <tr>
                <td v-if="item !='seedcode'&&item!='unitguid'&&item!='totalmoneytax'&&item!='discount'"
                    style="text-align: center"
                    v-for="item in column">
                  {{item}}
                </td>
                <td style="text-align: center" v-if="totalnumber>1">拆单数</td>

              </tr>
              <tr v-for="item in tableData" style="cursor:pointer;">
                <td
                  :style="{textAlign:ob['产品名称']?'left':'center',minWidth:ob['产品名称']?'150px':''}"
                  v-for="(ob,index) in item"
                  v-if="index!=0&&typeof(ob['unitguid'])=='undefined'&&typeof(ob['totalmoneytax'])=='undefined'&&typeof(ob['discount'])=='undefined'&&typeof(ob['pcustomerguid'])=='undefined'&&typeof(ob['pcustomer'])=='undefined'&&typeof(ob['chaidannumber'])=='undefined'">
                  <span v-for="value in ob">{{value}}</span>
                </td>
                <td
                  v-for="(ob,index) in item"
                  v-if="typeof(ob['chaidannumber'])!='undefined'&&totalnumber>1">
                  <input type="text" v-model="ob['chaidannumber']" placeholder="请输入拆单数" @click="chaidannumber(item)"/>
                </td>
                <!--<td-->
                <!--v-for="(ob,index) in item"-->
                <!--v-if="typeof(ob['pcustomer'])!='undefined'&&filltemplate!=50">-->
                <!--<input type="text" v-model="ob['pcustomer']" placeholder="选择供应商" @click="showChaiDan(item)"/>-->
                <!--</td>-->

              </tr>
            </table>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right">说&nbsp;&nbsp;&nbsp;&nbsp;明：</td>
          <td colspan="5" style="border: none;height: 30px">
            <div v-html="getLiuYan(controlData.remark)"></div>
          </td>
        </tr>
      </table>

    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="delivergoods" class="qrbtn" :loading="loading">保存</el-button>
    </div>


    <CstagreementEditSeedDetail ref="seeddetail"></CstagreementEditSeedDetail>
    <!--<ExternaldeptSel ref="chaidan" :unitgroup="3" @select="afterChaiDan"-->
    <!--:title="'选择供应商'"></ExternaldeptSel>-->
    <ExternaldeptChaiDanSel ref="chaidan" :unitgroup="3" @select="afterChaiDan"
                            :title="'选择供应商'"></ExternaldeptChaiDanSel>
  </el-dialog>
</template>


<script>

  import {getPrice} from '@/api/set/goodsprice';
  import {printing, jxcstorelist, chaifenOrder} from '@/api/set/csagreement';
  import {getParameterDetail} from '@/api/set/parameter';
  import {saveOutboundDataNew} from '@/api/set/warehouse';
  import SelEmployee from '../../common/CommonTree';
  import CstagreementEditSeedDetail from './CstagreementEditSeedDetail'
  import {getRemark} from '@/plugin/ordercommon'
  // import ExternaldeptSel from '@/components/set/externaldept/ExternaldeptSel'
  import ExternaldeptChaiDanSel from '@/components/set/externaldept/ExternaldeptChaiDanSel'
  import {saveData} from '@/api/set/handlelog';

  export default {
    name: 'CstagreementEditChaiDan',
    data() {
      return {
        dialogFormVisible: false,
        loading: false,
        parameterData: [],
        deliveryaddress: '',
        form: {
          erpserial: "",
          deliverymode: 10,
          logisticsco: '',
          logisticsnum: '',
          customername: '',
          customerserial: '',
          independentserial: '',
          cangkucode: '',
          cangkuname: '',
          origionstatus: '',
          jxcformDetailDo: '',
        },
        formLabelWidth: '120px',
        jxcstoreData: [],
        tableData: [],
        unitguid: "",
        column: [],
        controlData: {},
        itemtemp: {},//操作某条记录的临时变量
        seedcodes: [],
        filltemplate: '',//商品类型
        totalnumber: 0,//商品数量
      }

    },
    methods: {
      //处理日志
      handlelog() {
        var handlelog = {}
        handlelog.erpserial = this.controlData.erpserial
        handlelog.isopen = 1
        handlelog.casestepname = '拆单'
        var temp = '';
        temp = ',商品编码:' + this.itemtemp[0].seedcode + ',更换供应商为:' + this.itemtemp[13].pcustomer
        handlelog.remark = '订单号：' + this.controlData.erpserial + temp
        saveData(handlelog).then(response => {
        })
      },
      afterChaiDan(pcustomerguid, pcustomer) {
        for (let i in this.itemtemp) {
          if (typeof this.itemtemp[i]["pcustomerguid"] != "undefined") {
            this.itemtemp[i]["pcustomerguid"] = pcustomerguid
          } else if (typeof this.itemtemp[i]["pcustomer"] != "undefined") {
            this.itemtemp[i]["pcustomer"] = pcustomer
          }

        }
      },

      formatTime() {
        var data = new Date();
        var year = data.getFullYear();
        var month = data.getMonth() + 1;
        var day = data.getDate();
        var hour = data.getHours();
        var minute = data.getMinutes();
        var second = data.getSeconds();
        return year + '-' + month + '-' + day + " " + hour + ":" + minute + ":" + second;
      },
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },
      // print1() {
      //   this.showtitle1=""
      //   this.$nextTick(()=>{
      //     this.$print(this.$refs.print1)
      //     this.showtitle1="none"
      //   })
      // },
      show() {
        this.dialogFormVisible = true;
      },
      //加工单数量大于1，可拆单
      chaidannumber(item) {
        console.log(JSON.stringify(item))
      },
      showChaiDan(item) {
        this.seedcodes = []
        this.itemtemp = item
        for (let i = 0; i < item.length; i++) {
          this.seedcodes.push(item[i]["seedcode"])
          break
        }
        this.$refs.chaidan.initData(this.seedcodes)
        this.$refs.chaidan.show()

      },
      getLiuYan(remark) {
        return getRemark(remark);
      },
      initData(row) {
        this.initForm()
        this.filltemplate = row.jxcformdetailDOList[0].filltemplate
        this.totalnumber = row.jxcformdetailDOList[0].totalnumber
        this.form.erpserial = row.erpserial
        this.form.customername = row.customername
        this.unitguid = row.unitguid
        printing({unitguid: row.unitguid, needunitguid: '1'}).then(response => {
          this.controlData = response.data.obj.detail;
          this.tableData = response.data.obj.goodsDetail;
          if (this.tableData.length > 0) {
            //取出表头
            let temparr = []
            let biaoji = 0
            for (let i in this.tableData) {
              for (let j in this.tableData[i]) {
                if (j == "R/L") {
                  biaoji = 1
                }
                if (j != "seedcode" && j != "R/L" && j != "数量" && j != "说明" && j != "产品名称" && j != "球镜" && j != "柱镜" && j != "轴位" && !this.contains(j, temparr)) {
                  temparr.push(j)
                }
              }
            }
            //对表头排序
            this.column.push("seedcode")
            if (biaoji == 1) {
              this.column.push("R/L")
            }
            this.column.push("产品名称")
            this.column.push("球镜")
            this.column.push("柱镜")
            this.column.push("轴位")
            this.column = this.column.concat(temparr)
            this.column.push("数量")
            // this.column.push("操作")

            this.tableData = this.tableData.map(o1 => this.column.map(o2 => {
              let ob = {}
              ob[o2] = o1[o2]
              return ob
            }))

            this.tableData.forEach(o => {
              o.push({pcustomerguid: ""})
              o.push({pcustomer: ""})
              o.push({chaidannumber: ""})

            })

          }
        });

      },
      delivergoods() {
        //提交前判断根据拆分的数量和订单的数量是否一样，都相同不可拆分订单
        var flage = true
        for (let i in this.tableData) {
          var chaidannumber = '';
          var number = ''
          for (let j in this.tableData[i]) {
            if (this.tableData[i][j]['数量'] != undefined) {
              number = this.tableData[i][j]['数量']
            } else if (this.tableData[i][j]['chaidannumber'] != undefined) {
              chaidannumber = this.tableData[i][j]['chaidannumber']
            }
          }
          if (chaidannumber != number)
            flage = false
        }
        if (flage) {
          this.$message({
            type: 'error',
            message: '不拆分',
          })
          return
        }
        this.loading = true;
        chaifenOrder({
          tableData: JSON.stringify(this.tableData),
          controlData: JSON.stringify(this.controlData),
          filltemplate: this.filltemplate,
        }).then(response => {
          if (response.data.code == 0) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.dialogFormVisible = false;
            this.handlelog();
            //刷新列表
            this.$emit("bindGrid")
            this.itemtemp.pcustomerguid = pcustomerguid
            this.itemtemp.pcustomer = customername
          } else {
            this.loading = false;
            this.$message.error('操作失败')
          }
        })
      },

      initForm() {
        this.loading = false;
        this.itemtemp = {}
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.groupguid = ""
        this.column = []
        this.tableData = []
        this.unitguid = ""
        this.filltemplate = ''
        this.totalnumber = 0

      }

    },
    mounted() {
      // jxcstorelist().then(response => {
      //   this.jxcstoreData = response.data.obj
      //   this.form.cangkucode = this.jxcstoreData[0].cangkucode
      // })
    },
    components: {
      CstagreementEditSeedDetail,
      SelEmployee,
      // ExternaldeptSel
      ExternaldeptChaiDanSel
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>




// WEBPACK FOOTER //
// src/components/testorder/cstagreement/CstagreementEditChaiDan.vue